import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { customerResource } from './../../system/customerManage/request';
import { applicationResource } from './../../customer/applicationManage/request';
import { auditList, markList, typeList, auditStatus, delAudit } from './request';
import { auditTypeResource } from './../typeManage/request';
export default {
  data() {
    return {
      markList,
      typeList,
      form: {},
      data: [],
      customerList: [],
      applicationList: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80
      }, {
        slots: {
          title: 'ID'
        },
        dataIndex: 'auditFlowId',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '审核流名称'
        },
        dataIndex: 'name',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '审核流类型'
        },
        dataIndex: 'auditFlowTypeName',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '标识'
        },
        dataIndex: 'flowMark',
        key: '10',
        align: 'center',
        scopedSlots: {
          customRender: 'flowMark'
        }
      }, {
        slots: {
          title: '所属客户'
        },
        dataIndex: 'customerName',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '创建人'
        },
        dataIndex: 'creator',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '8',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 180,
        key: '9'
      }]
    };
  },
  created() {
    customerResource({}).then(res => {
      this.customerList = res;
    });
    auditTypeResource({}).then(res => {
      this.typeList = res;
    });
    this.getDataFun();
  },
  methods: {
    applicationFun() {
      applicationResource({
        customerId: this.form.customerId
      }).then(res => {
        this.applicationList = res;
      });
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      auditList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleAdd() {
      this.auditShow = true;
      this.$nextTick(() => {
        this.$refs.auditFrom.init();
      });
    },
    handleEdit(val) {
      this.auditShow = true;
      this.$nextTick(() => {
        this.$refs.auditFrom.init(val.auditFlowId);
      });
    },
    checkedFun(val) {
      if (!this.isAuth('home.auditFlowStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      auditStatus({
        auditFlowId: val.auditFlowId,
        status: val.status == 'ONLINE' ? 'OFFLINE' : 'ONLINE'
      }).then(res => {
        this.$message.success(this.$t('操作成功') + '!');
        this.getDataFun();
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该审核流') + '?', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delAudit({
          auditFlowId: val.auditFlowId
        }).then(() => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getDataFun();
        });
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    checkedItem(val) {
      return val == 'ONLINE' ? true : false;
    },
    flowMarkFun(val) {
      let name = '';
      this.markList.map(item => {
        if (item.value == val) {
          name = item.name;
        }
      });
      return this.$t(name);
    }
  }
};